import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "package",
    "newPackage",
    "newPackageField",
    "packageStatus",
    "destinationHelp",
    "submitHelp",
    "submit"
  ]

  static values = {
    categoriesAvailable: Boolean,
    packageStatuses: Object
  }

  connect() {
    this.sync()
  }

  sync() {
    const newPackage = this.packageTarget.value === "new"
    const noDestination = this.packageTarget.value === ""
    const visibleExistingPackage = !newPackage &&
      this.packageStatusesValue[this.packageTarget.value] === "published"

    this.newPackageTarget.hidden = !newPackage
    this.newPackageFieldTarget.required = newPackage
    this.submitTarget.disabled = !this.categoriesAvailableValue || noDestination

    if (noDestination) {
      this.destinationHelpTarget.textContent = "Choose an existing package or create one for this file."
      this.submitHelpTarget.textContent = "Choose a destination to continue."
      this.submitTarget.value = "Add to package"
      return
    }

    if (!newPackage) {
      const visibility = visibleExistingPackage
        ? "Company users will see this file immediately."
        : "The file stays hidden while this package is Draft."
      this.destinationHelpTarget.textContent = visibility
      this.submitHelpTarget.textContent = `${visibility} No email is sent.`
      this.submitTarget.value = "Add to package"
      this.submitTarget.disabled = !this.categoriesAvailableValue
      return
    }

    const visible = this.packageStatusTargets.find(input => input.checked)?.value === "published"
    this.destinationHelpTarget.textContent = "A new package will be created for this file."
    this.submitHelpTarget.textContent = visible
      ? "The new package and file will be visible immediately. No email is sent."
      : "The new package will stay Draft and hidden from company users."
    this.submitTarget.value = "Create package and add file"
    this.submitTarget.disabled = !this.categoriesAvailableValue
  }
}
